module.exports = __webpack_public_path__ + "static/media/hour.b6cae384.svg";